var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{attrs:{"src":_vm.brand.logo.src,"width":_vm.brand.logo.width,"height":"56px","alt":_vm.brand.productName + ' Logo'}})
}
var staticRenderFns = []

export { render, staticRenderFns }